export const styles = {
  container: {
    backgroundColor: "white",
    width: "100%",
    marginTop: "auto",
  },
  upperFooterContainer: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: { xs: "center", md: "space-between" },
    alignItems: { xs: "center", md: "flex-start" },
    padding: {
      xs: "24px 20px",
      sm: "30px 40px",
      md: "36px 20px",
      lg: "36px 60px",
    },
    gap: { xs: "32px", md: "20px" },
  },
  leftSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: { xs: "center", md: "flex-start" },
    width: { xs: "100%", md: "auto" },
    maxWidth: "100%",
  },
  rightSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: { xs: "center", md: "flex-end" },
    justifyContent: "space-between",
    width: { xs: "100%", md: "auto" },
  },
  logoContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px",
    marginBottom: { xs: "16px", md: "20px" },
    flexWrap: { xs: "wrap", md: "nowrap" },
    justifyContent: { xs: "center", md: "flex-start" },
    maxWidth: "100%",
  },
  logoDivider: {
    width: "1px",
    height: "32px",
    backgroundColor: "#2E2E2E",
  },
  navLinks1: {
    display: "flex",
    gap: { xs: "16px", md: "22px" },
    flexWrap: "wrap",
    marginBottom: "9px",
    justifyContent: { xs: "center", md: "flex-start" },
    width: "100%",
  },
  navLink1: {
    textDecoration: "none",
    fontWeight: 500,
    textTransform: "uppercase",
    color: "#B1BEC7 !important",
    fontSize: { xs: "16px", md: "19px" },
  },
  navLink2: {
    textDecoration: "none",
    fontWeight: 500,
    fontSize: { xs: "12px", md: "14px" },
    color: "#2E2E2E !important",
  },
  navLinks2: {
    display: "flex",
    gap: { xs: "8px", md: "12px" },
    flexWrap: "wrap",
    justifyContent: { xs: "center", md: "flex-start" },
    width: "100%",
  },
  navLinkDivider: {
    width: "1px",
    height: "16px",
    backgroundColor: "#2E2E2E",
  },
  createEventButton: {
    marginBottom: { xs: "24px", md: "36px" },
    width: { xs: "100%", md: "auto" },
  },
  bottomSection: {
    backgroundColor: "#CFD8DC",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "center", md: "center" },
    padding: {
      xs: "24px 16px",
      sm: "24px 40px",
      md: "23px 75px",
    },
    gap: { xs: "16px", md: "0" },
  },
  termsLinks: {
    display: "flex",
    gap: { xs: "20px", sm: "30px", md: "38px" },
    flexWrap: "wrap",
    marginLeft: { xs: "0px", md: "75px" },
    justifyContent: { xs: "center", md: "flex-start" },
    width: { xs: "100%", md: "auto" },
  },
  termsLink: {
    color: "events.lightBlack",
    textDecoration: "none",
    fontSize: { xs: "11px", md: "12px" },
    fontWeight: 500,
  },
  copyright: {
    color: "events.lightBlack",
    fontSize: { xs: "10px", md: "10px" },
    fontWeight: 500,
    textAlign: { xs: "center", md: "right" },
    width: { xs: "100%", md: "auto" },
  },
  socialLinks: {
    display: "flex",
    gap: { xs: "12px", md: "16px" },
    marginTop: { xs: "16px", md: 0 },
    justifyContent: { xs: "center", md: "flex-end" },
    width: { xs: "100%", md: "auto" },
  },
  socialButton: {
    width: { xs: "24px", md: "26px" },
    height: { xs: "24px", md: "26px" },
    borderRadius: "50%",
    backgroundColor: "events.blueSecondary",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    textDecoration: "none",
  },
  blueDot: {
    marginTop: "20px",
  },
};
